import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    company: {
      subtitle:
        'This information corresponds to that shown on your Kbis certificate.',
      title: 'Your company information',
    },
    financialTitle: 'Your financial situation',
    reset: 'Reset my account',
    title: 'General Information',
  },

  fr: {
    company: {
      subtitle:
        'Ces informations correspondent à celles indiquées sur votre Kbis',
      title: 'Informations de votre entreprise',
    },
    financialTitle: 'Votre situation fiscale',
    reset: 'Réinitialiser mon compte',
    title: 'Informations générales',
  },
} as const);
